import { render, staticRenderFns } from "./EditOpeningHours.vue?vue&type=template&id=b6d3435c&scoped=true&"
import script from "./EditOpeningHours.vue?vue&type=script&lang=ts&"
export * from "./EditOpeningHours.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d3435c",
  null
  
)

export default component.exports